import React, { useEffect, useState } from 'react';
import { Container, Alert, Button, Spinner } from 'react-bootstrap';
import { Link, Navigate } from 'react-router-dom';
import featureFlagService, { FEATURES } from '../services/featureFlagService';

/**
 * Payment success page displayed after a successful Stripe checkout
 */
const PaymentSuccessPage = () => {
  const [loading, setLoading] = useState(true);
  const [paymentsEnabled, setPaymentsEnabled] = useState(false);

  useEffect(() => {
    const checkFeatureFlag = async () => {
      try {
        const isEnabled = featureFlagService.isFeatureEnabled(FEATURES.STRIPE_PAYMENTS);
        setPaymentsEnabled(isEnabled);
        
        if (isEnabled) {
          // You could trigger any post-payment success actions here
          // For example, refreshing user subscription status
          console.log('Payment completed successfully');
        }
      } finally {
        setLoading(false);
      }
    };
    
    checkFeatureFlag();
  }, []);

  if (loading) {
    return (
      <Container className="my-5 text-center">
        <Spinner animation="border" role="status">
          <span className="visually-hidden">Loading...</span>
        </Spinner>
      </Container>
    );
  }

  // If payments are disabled, redirect to home page
  if (!paymentsEnabled) {
    return <Navigate to="/" />;
  }

  return (
    <Container className="my-5 text-center">
      <Alert variant="success" className="mb-4">
        <Alert.Heading>Payment Successful!</Alert.Heading>
        <p>
          Thank you for your payment. Your premium features have been activated.
        </p>
      </Alert>
      
      <p className="mb-4">
        You now have access to all premium features of RxRooster. Enjoy the enhanced experience!
      </p>
      
      <div className="d-flex justify-content-center gap-3">
        <Button as={Link} to="/dashboard" variant="primary">
          Go to Dashboard
        </Button>
        <Button as={Link} to="/" variant="outline-secondary">
          Return Home
        </Button>
      </div>
    </Container>
  );
};

export default PaymentSuccessPage;
